export default __webpack_public_path__ + "static/media/bulb.ae6076a1.png";